module.exports = __webpack_public_path__ + "img/mastercard.14f474cf.png";